import AuthBase from "../AuthBase";
import {
    Grid,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Loading from "../../components/Loading";
import OwnData from "./components/OwnData";
import PasswordReset from "./components/PasswordReset";
import Payment from "./payment/Payment";
import Billing from "./billingNew/Billing";
import ApiKey from "./api-key/ApiKey";
import Subscription from "./components/Subscription";
import Cards from "./components/Cards";
import DeleteAccount from "./components/DeleteAccount";
import Calendar from "./components/Calendar";
import SmsTokens from "./components/SmsTokens";
import InvoiceData from "./components/InvoiceData";
import useColleagueQueries from "../../hooks/queries/useColleagueQueries";
import useBusinessQueries from "../../hooks/queries/useBusinessQueries";
import {useSnackbar} from "notistack";


const Settings = () => {
    const {getUserQuery, updateColleagueMutation, changePasswordMutation} = useColleagueQueries()
    const {businessGetBusinessQuery, updateBusinessMutation} = useBusinessQueries()
    const {data: currentUser, isPending: userLoading} = getUserQuery
    const {data: business, isPending: businessLoading} = businessGetBusinessQuery
    const {enqueueSnackbar} = useSnackbar()

    const editBusiness = data => updateBusinessMutation.mutate({id: business.id, data: data}, {
        onSuccess: () => enqueueSnackbar('Mentve!', {variant: 'success'})
    })
    const handleEditMe = data => updateColleagueMutation.mutate({id: currentUser.id, data: data}, {
        onSuccess: () => enqueueSnackbar('Mentve!', {variant: 'success'})
    })
    const changePassword = data => changePasswordMutation.mutate(data, {
        onSuccess: () => enqueueSnackbar('Mentve!', {variant: 'success'})
    })

    if (userLoading || businessLoading) return <Loading isLoading />

    return <AuthBase label='Beállítások'>
        <div className="main">
            <Grid container spacing={2}>

                <Grid item xs={12}>
                    <div className="white-card">
                        <Typography variant='subtitle1'>Saját adatok módosítása</Typography>
                        <Typography variant='body2' color='#536B74'>
                            Itt tudod módosítani az adminiszrátori felhasználó
                            adatait. Ezen adatokat a Kollégák résznél is módosíthatod.
                        </Typography>
                        <OwnData data={currentUser} handleSubmit={handleEditMe}/>
                    </div>
                </Grid>


                <Grid item xs={12}>
                    <div className="white-card">
                        <Typography variant='subtitle1'>
                            Számlázási és SimplePay adattovábbítási adatok módosítása
                        </Typography>
                        <Typography variant='body2' color='#536B74'>
                            Itt tudod modósítani a számlázási és SimplePay adattovábbítási nyilatkozathoz tartozó
                            adataidat.
                        </Typography>
                        <InvoiceData
                            data={business}
                            handleSubmit={editBusiness}
                        />
                    </div>
                </Grid>


                <Grid item xs={12}>
                    <div className="white-card">
                        <Typography variant='subtitle1'>Jelszó módosítása</Typography>
                        <Typography variant='body2' color='#536B74'>
                            Kérjük változtasd meg rendszeresen a jelszavadat és ne add meg senkinek!
                        </Typography>
                        <PasswordReset handleSubmit={changePassword}/>
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <Billing/>
                </Grid>

                <Grid item xs={12}>
                    <Payment/>
                </Grid>

                <Grid item xs={12}>
                    <SmsTokens business={business}/>
                </Grid>

                <Grid item xs={12}>
                    <Subscription />
                </Grid>

                <Grid item xs={12}>
                    <Cards/>
                </Grid>

                <Grid item xs={12}>
                    <Calendar/>
                </Grid>

                <Grid item xs={12}>
                    <ApiKey/>
                </Grid>

                <Grid item xs={12}>
                    <DeleteAccount/>
                </Grid>
            </Grid>
        </div>
    </AuthBase>
}

export default Settings